import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import type { InferContractRouterOutputs } from '@orpc/contract';
import { useQuery } from '@tanstack/react-query';
import type { Contract } from '@/lib/orpc/contracts';
import { useWeb3Context } from '@/contexts/Web3Context';
import { orpc } from '@/lib/orpc/client';
export type AutoDeleverageDialogToken = InferContractRouterOutputs<Contract>['market']['autoDeleverageDialog']['loanToken'];

/** The market labels and LLTV the auto-deleverage dialog and its recap show. */
export function useAutoDeleverageDialogData(marketId) {
  const $ = _c(3);
  const {
    targetChainId
  } = useWeb3Context();
  let t0;
  if ($[0] !== marketId || $[1] !== targetChainId) {
    t0 = orpc.market.autoDeleverageDialog.queryOptions({
      input: {
        chainId: targetChainId,
        marketId
      },
      staleTime: Infinity
    });
    $[0] = marketId;
    $[1] = targetChainId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useQuery(t0);
}